module.exports = __webpack_public_path__ + "img/audit.d8acaa1c.svg";